import {Routes} from '@angular/router';
import {IndexComponent as EMailIndexComponent} from './index/index.component';
import EMailEditComponent from './edit/edit.component';
import {ContentComponent as EMailContentComponent} from './content/content.component';
import {canActivateGuard} from '../../../guards/can-activate-guard';
import {Backend, PERMISSION} from '@generated-backend-types';
import {EmailService} from '../../../services/api/administration/email.service';
import PatientLanguageEnum = Backend.App.Enums.PatientLanguageEnum;

export const routes: Routes = [
  {
    path: '',
    component: EMailIndexComponent,
    canActivate: [canActivateGuard],
    data: {
      allPermissionsNeeded: [PERMISSION.ADMINISTRATION_EMAIL_READ_ALL],
      breadcrumb: [
        {
          label: 'authenticated.administration.emails.index.breadcrumb',
          translate: true,
          route: '/administration/emails'
        },
      ]
    }
  },
  {
    path: 'add',
    component: EMailEditComponent,
    canActivate: [canActivateGuard],
    data: {
      allPermissionsNeeded: [PERMISSION.ADMINISTRATION_EMAIL_CREATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.administration.emails.index.breadcrumb',
          translate: true,
          route: '/administration/emails'
        },
        {label: 'authenticated.administration.emails.create.breadcrumb', translate: true,},
      ]
    }
  },
  {
    path: ':id',
    component: EMailEditComponent,
    canActivate: [canActivateGuard],
    resolve: {
      email: EmailService,
    },
    data: {
      allPermissionsNeeded: [PERMISSION.ADMINISTRATION_EMAIL_UPDATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.administration.emails.index.breadcrumb',
          translate: true,
          route: '/administration/emails'
        },
        {dynamic: true, dataKey: 'email.title', route: '/administration/emails/:id'},
        {label: 'authenticated.administration.emails.edit.breadcrumb', translate: true,},
      ]
    }
  },
  {
    path: ':id/german',
    component: EMailContentComponent,
    canActivate: [canActivateGuard],
    resolve: {
      email: EmailService,
    },
    data: {
      language: PatientLanguageEnum.GERMAN,
      allPermissionsNeeded: [PERMISSION.ADMINISTRATION_EMAIL_UPDATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.administration.emails.index.breadcrumb',
          translate: true,
          route: '/administration/emails'
        },
        {dynamic: true, dataKey: 'email.title', route: '/administration/emails/:id'},
        {label: 'authenticated.administration.emails.content.german.breadcrumb', translate: true,},
      ]
    }
  },
  {
    path: ':id/english',
    component: EMailContentComponent,
    canActivate: [canActivateGuard],
    resolve: {
      email: EmailService,
    },
    data: {
      language: PatientLanguageEnum.ENGLISH,
      allPermissionsNeeded: [PERMISSION.ADMINISTRATION_EMAIL_UPDATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.administration.emails.index.breadcrumb',
          translate: true,
          route: '/administration/emails'
        },
        {dynamic: true, dataKey: 'email.title', route: '/administration/emails/:id'},
        {label: 'authenticated.administration.emails.content.english.breadcrumb', translate: true,},
      ]
    }
  },
  {
    path: ':id/russian',
    component: EMailContentComponent,
    canActivate: [canActivateGuard],
    resolve: {
      email: EmailService,
    },
    data: {
      language: PatientLanguageEnum.RUSSIAN,
      allPermissionsNeeded: [PERMISSION.ADMINISTRATION_EMAIL_UPDATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.administration.emails.index.breadcrumb',
          translate: true,
          route: '/administration/emails'
        },
        {dynamic: true, dataKey: 'email.title', route: '/administration/emails/:id'},
        {label: 'authenticated.administration.emails.content.russian.breadcrumb', translate: true,},
      ]
    }
  },
];
